<template>
  <v-app class="disable-select">
    <v-navigation-drawer
      mobile-break-point="300"
      v-if="isNavigationVisible"
      persistent
      :mini-variant="isNavigationDrawerMiniVariant"
      :clipped="navigationClipped"
      v-model="showLeftNavigationDrawer"
      mini-variant-width="150"
      enable-resize-watcher
      fixed
      app
    >
      <v-toolbar height="48">
        <span style="cursor: default;">Units</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.stop="
            isNavigationDrawerMiniVariant = !isNavigationDrawerMiniVariant
          "
          v-if="showLeftNavigationDrawer"
        >
          <v-icon
            v-html="
              isNavigationDrawerMiniVariant ? 'chevron_right' : 'chevron_left'
            "
          ></v-icon>
        </v-btn>
      </v-toolbar>

      <v-list class="pt-0">
        <v-list-tile
          :class="unit === selectedUnit ? 'selectedUnitNavigationTile' : ''"
          value="true"
          v-for="(unit, index) in myUnits"
          :key="index"
          @click.stop="selectUnitToView(unit)"
        >
          <unit-navigation-tile
            :unit="unit"
            :useShortName="isNavigationDrawerMiniVariant"
            :isSelected="unit === selectedUnit"
          ></unit-navigation-tile>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      mobile-break-point="300"
      v-if="isNavigationVisible"
      :right="true"
      :clipped="true"
      v-model="showRightNavigationDrawer"
      fixed
      app
    >
      <legend-drawer></legend-drawer>
    </v-navigation-drawer>

    <v-toolbar
      height="48"
      class="ntstAppToolbar"
      v-if="isNavigationVisible"
      app
      :clipped-left="navigationClipped"
      :clipped-right="navigationClipped"
    >
      <v-btn
        icon
        @click.stop="showLeftNavigationDrawer = !showLeftNavigationDrawer"
      >
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title class="title">
        <router-link to="/" style="cursor: pointer;">
          <v-layout row>
            <img
              src="./assets/images/Netsmart_logo_people_only.png"
              class="titleImage"
            />
            <div class="titleText">BedBoard</div>
          </v-layout>
        </router-link>
      </v-toolbar-title>

      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer />

      <unit-navigation-tile
        class="toolbarSelectedUnitTile"
        v-if="selectedUnit"
        :unit="selectedUnit"
        :isSelected="true"
        :useShortName="false"
      ></unit-navigation-tile>

      <v-spacer />

      <span v-if="selectedUnit">
        <v-tooltip bottom>
          <v-btn
            xs
            icon
            flat
            class="ntstAppIcon"
            slot="activator"
            @click.stop="increaseRoomSize()"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <span>Make rooms larger</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            xs
            icon
            flat
            class="ntstAppIcon"
            slot="activator"
            @click.stop="decreaseRoomSize()"
          >
            <v-icon>fas fa-minus</v-icon>
          </v-btn>
          <span>Make rooms smaller</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            xs
            icon
            flat
            class="ntstAppIcon"
            slot="activator"
            @click.stop="showUnitAlerts()"
          >
            <v-icon>fas fa-exclamation-circle</v-icon>
          </v-btn>
          <span>View alerts for all stays</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            xs
            icon
            flat
            class="ntstAppIcon"
            slot="activator"
            @click.stop="showUnitClients()"
          >
            <v-icon>fas fa-users</v-icon>
          </v-btn>
          <span>View images for all stays</span>
        </v-tooltip>
      </span>

      <v-tooltip bottom>
        <v-btn
          xs
          icon
          flat
          class="ntstAppIcon"
          slot="activator"
          @click.stop="refreshConfiguration(true)"
        >
          <v-icon>fas fa-sync-alt</v-icon>
        </v-btn>
        <span>Refresh the data</span>
      </v-tooltip>

      <v-tooltip bottom v-if="selectedUnit">
        <v-btn
          xs
          icon
          flat
          class="ntstAppIcon"
          slot="activator"
          @click.stop="showRightNavigationDrawer = !showRightNavigationDrawer"
        >
          <v-icon>fas fa-map-signs</v-icon>
        </v-btn>
        <span>Legend</span>
      </v-tooltip>

      <v-divider inset vertical></v-divider>

      <v-tooltip bottom>
        <v-btn
          xs
          icon
          flat
          slot="activator"
          @click.stop="showUserPreferences()"
        >
          <v-icon>settings</v-icon>
        </v-btn>
        <span>Preferences</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn xs icon flat slot="activator" @click.stop="showAbout()">
          <v-icon>fas fa-info-circle</v-icon>
        </v-btn>
        <span>About BedBoard</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!isLogoutDisabled">
        <v-btn xs icon flat slot="activator" @click.stop="logout()">
          <v-icon>fas fa-sign-out-alt</v-icon>
        </v-btn>
        <span>Log out</span>
      </v-tooltip>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer
      class="elevation-3"
      style="cursor: default;"
      :fixed="isFooterFixed"
      app
    >
      <v-layout row>
        <v-flex xs3 />
        <v-flex xs6 class="text-xs-center">
          <span class="ntstAppFooter">
            <span
              >&copy; Netsmart Technologies, Inc.
              {{ new Date() | moment('YYYY') }}</span
            >
          </span>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <span class="versionLabel">BedBoard App {{ appVersion }}&nbsp;</span>
        </v-flex>
      </v-layout>
    </v-footer>

    <v-dialog
      v-if="isUnitAlertsDialogVisible"
      v-model="isUnitAlertsDialogVisible"
      scrollable
      min-height="90%"
      width="800px"
    >
      <v-flex>
        <unit-alerts-card
          :unit="selectedUnit"
          :onClose="closeUnitAlertsDialog"
        ></unit-alerts-card>
      </v-flex>
    </v-dialog>

    <v-dialog
      v-if="isUnitClientsDialogVisible"
      v-model="isUnitClientsDialogVisible"
      scrollable
      min-height="90%"
      width="90%"
    >
      <v-flex>
        <unit-clients-card
          :unit="selectedUnit"
          :onClose="closeUnitClientsDialog"
        ></unit-clients-card>
      </v-flex>
    </v-dialog>

    <v-dialog
      v-if="isUserPreferencesDialogVisible"
      v-model="isUserPreferencesDialogVisible"
      scrollable
      width="800px"
    >
      <v-flex>
        <user-preferences
          :onCancel="closeUserPreferencesDialog"
          :onSave="saveUserPreferences"
        />
      </v-flex>
    </v-dialog>

    <v-dialog
      style="overflow-y:none;"
      v-if="isBusyIndicatorVisible"
      v-model="isBusyIndicatorVisible"
      persistent
      min-height="100px"
      width="210px"
    >
      <div
        style="text-align:center; background-color: #fff; padding-bottom: 10px;"
      >
        <busy-animation></busy-animation>
        <div class="ntstLoadingLabel">Loading...</div>
      </div>
    </v-dialog>

    <v-dialog
      v-if="isConfigurationErrorDialogVisible"
      v-model="isConfigurationErrorDialogVisible"
      persistent
      height="450px"
      width="550px"
    >
      <v-flex>
        <configuration-error
          :onLogout="configurationErrorLogout"
          :onRetry="retrySelectConfiguration"
        ></configuration-error>
      </v-flex>
    </v-dialog>
  </v-app>
</template>

<script lang="js">

import moment from 'moment';

import appSettings from './appSettings';

import BusyAnimation from './components/BusyAnimation.vue';
import ConfigurationError from './components/ConfigurationError.vue';
import LegendDrawer from './components/LegendDrawer.vue';
import UnitAlertsCard from './components/UnitAlertsCard.vue';
import UnitClientsCard from './components/UnitClientsCard.vue';
import UnitNavigationTile from './components/UnitNavigationTile.vue';
import UserPreferences from './components/UserPreferences.vue';

import bedBoardUtils from './bedBoardUtils';


export default {
  name: 'App',
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      isBusyIndicatorVisible: false,
      isConfigurationErrorDialogVisible: false,
      isFooterFixed: true,
      isNavigationDrawerMiniVariant: true,
      isSSO: false,
      isUnitAlertsDialogVisible: false,
      isUnitClientsDialogVisible: false,
      isUserPreferencesDialogVisible: false,
      navigationClipped: true,
      showLeftNavigationDrawer: true,
      showRightNavigationDrawer: false,
    };
  },
  timers: [
    { name: 'checkAuthTimer', time: appSettings.defaultAuthTimerCheckEveryXSeconds * 1000, repeat: true },
    // { name: 'refreshConfigTimer', time: appSettings.defaultRefreshEveryXSeconds * 1000, repeat: true }
  ],
  onIdle() {
    // this.timers.refreshConfigTimer.time = this.$store.getters.refreshEveryXSeconds ? this.$store.getters.refreshEveryXSeconds * 1000 : appSettings.defaultRefreshEveryXSeconds * 1000;
    // if (this.$sdkAuth.isUserAuthenticated() && !this.isConfigurationErrorDialogVisible) {
    //   this.$timer.start('refreshConfigTimer');
    // }
  },
  onActive() {
    // this.$timer.stop('refreshConfigTimer');
  },
  components: {
    'busy-animation': BusyAnimation,
    'configuration-error': ConfigurationError,
    'legend-drawer': LegendDrawer,
    'unit-alerts-card': UnitAlertsCard,
    'unit-clients-card': UnitClientsCard,
    'unit-navigation-tile': UnitNavigationTile,
    'user-preferences': UserPreferences
  },
  beforeDestroy() {
    if (this.isSSO) {
      this.$log.info(`[${moment().format(appSettings.logDateFormat)}] Before destorying Vue app, since this session logged in with SSO, removing any previous session data.`);
      this.$sdkAuth.logoutSSO();
    }
  },
  created() {
    this.$eventbus.$on('SetIsLogoutDisabled', (isLogoutDisabled) => {
      this.$store.commit('setIsLogoutDisabled', isLogoutDisabled);
    });
    this.$eventbus.$on('LoginSuccessful', async () => {
      const scope = this.$sdkAuth.getScope('session');
      await bedBoardUtils.addSignalR(this, scope);
      await this.setConfiguration(true);
      this.$store.commit('setNavigationVisibility', true);
      await this.$router.replace({ name: 'home' });
      this.$timer.start('checkAuthTimer');
      if (this.$store.getters.isOccupancyReportViewable) {
        this.$eventbus.$emit('GenerateOccupancyReport');
      }
      this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
    });
    this.$eventbus.$on('LogoutSuccessful', async (message) => {
      const scope = this.$sdkAuth.getScope('session');
      this.$timer.stop('checkAuthTimer');
      // this.$timer.stop('refreshConfigTimer');
      await bedBoardUtils.removeClientFromSignalRGroup(this, scope);
      await bedBoardUtils.removeSignalR(this);
      this.$store.commit('clearConfiguration');
      if (message) {
        this.$router.replace({ name: 'login', params: { message } });
      } else {
        this.$router.replace({ name: 'login' });
      }
      this.$store.commit('setNavigationVisibility', false);
    });
    this.$eventbus.$on('SetIsBusyIndicatorVisible', async (isBusy) => {
      this.isBusyIndicatorVisible = isBusy;
    });
    this.$eventbus.$on('roomStayDragStarted', () => {
    });
    this.$eventbus.$on('roomStayDragEnded', () => {
    });
    this.$eventbus.$on('showToast', (toastOptions) => {
      switch (toastOptions.type) {
        case 'error':
          this.$toasted.error(toastOptions.message, { icon: 'ban' });
          break;
        case 'info':
          this.$toasted.info(toastOptions.message, { icon: 'info-circle' });
          break;
        case 'show':
          this.$toasted.show(toastOptions.message, { icon: 'info' });
          break;
        case 'success':
          this.$toasted.success(toastOptions.message, { icon: 'check' });
          break;
        case 'warning':
          this.$toasted.success(toastOptions.message, { icon: 'exclamation-triangle' });
          break;
        default:
          this.$toasted.show(toastOptions.message, { icon: 'info' });
          break;
      }
    });

    if (this.$sdkAuth.isUserAuthenticated()) {
      this.$eventbus.$emit('SetIsBusyIndicatorVisible', true);
      this.$timer.start('checkAuthTimer');
    }
  },
  updated() {
    this.$store.commit('enableTransitionForStayTiles');
  },
  async mounted() {
    const { isSSO } = this.$route.query;
    this.isSSO = isSSO;
    if (this.isSSO) {
      this.$log.info(`[${moment().format(appSettings.logDateFormat)}] Logging in with SSO, removing any previous session data.`);
      this.$sdkAuth.logoutSSO();
      if (!this.$sdkAuth.isUserAuthenticated()) {
        if (this.$cookie.get('LoginParameters')) {
          const loginParameters = JSON.parse(this.$cookie.get('LoginParameters'));
          this.$cookie.delete('LoginParameters');

          await this.$sdkAuth
            .login(loginParameters)
            .then(async () => {
              this.$eventbus.$emit('SetIsBusyIndicatorVisible', true);
              this.$eventbus.$emit('LoginSuccessful');
            })
            .catch((err) => {
              this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
              this.$router.replace({ name: 'SSO login' });
              this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
            });
        } else {
          this.$log.error('Logging in with SSO but no login parameters found.');
        }
      }
    } else if (this.$sdkAuth.isUserAuthenticated()) {
      try {
        this.$eventbus.$emit('SetIsBusyIndicatorVisible', true);
        const scope = this.$sdkAuth.getScope('session');
        await bedBoardUtils.addSignalR(this, scope);
        this.$store.commit('setNavigationVisibility', true);
        await this.setConfiguration(true);
        this.$router.replace({ name: 'home' });
        this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
      } catch ({ error }) {
        this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${error.message}`);
        this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
      }
    } else {
      this.$log.info(`[${moment().format(appSettings.logDateFormat)}] User not authenticated, redirecting to login.`);
      this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
      this.$router.replace({ name: 'login' });
    }
  },
  computed: {
    isLogoutDisabled() {
      return this.$store.getters.isLogoutDisabled;
    },
    isNavigationVisible() {
      return this.$store.getters.isNavigationVisible;
    },
    myUnits() {
      return this.$store.getters.myUnits;
    },
    selectedUnit() {
      return this.$store.getters.selectedUnit;
    }
  },
  methods: {
    checkAuthTimer() {
      this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] CheckAuthTimer ticked: Updating auth, if needed...`);
      this.$sdkAuth.updateAuthIfNeeded()
        .then(async (authWasUpdated) => {
          if (authWasUpdated) {
            this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] CheckAuthTimer ticked: Auth was refreshed and updated.`);
          } else {
            this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] CheckAuthTimer ticked: Auth did not need to be refreshed.`);
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
          }
          if (err && err.logUserOut) {
            this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] App.checkAuthTimer.catch: Token has expired and unable to refresh token...logging the user out.`);
            this.$store.commit('setSelectedUnit', null);
            this.logout('Auth has expired.');
          }
        });
    },

    configurationErrorLogout() {
      this.isConfigurationErrorDialogVisible = false;
      this.logout();
    },

    closeUnitAlertsDialog() {
      this.isUnitAlertsDialogVisible = false;
    },

    closeUnitClientsDialog() {
      this.isUnitClientsDialogVisible = false;
    },

    closeUserPreferencesDialog() {
      this.isUserPreferencesDialogVisible = false;
    },

    decreaseRoomSize() {
      this.$store.commit('decreaseRoomSize');
      bedBoardUtils.raiseBedBoardUserPreferencesUpdated(this.$store.getters.userPreferences);
    },

    increaseRoomSize() {
      this.$store.commit('increaseRoomSize');
      bedBoardUtils.raiseBedBoardUserPreferencesUpdated(this.$store.getters.userPreferences);
    },

    logout(message) {
      this.$store.commit('setSelectedUnit', null);
      this.$sdkAuth.logout(message);
    },

    async refreshConfiguration(showPopupOnError) {
      this.$eventbus.$emit('SetIsBusyIndicatorVisible', true);
      await this.setConfiguration(showPopupOnError);
      this.$eventbus.$emit('SetIsBusyIndicatorVisible', false);
    },

    refreshConfigTimer() {
      this.$log.debug(`[${moment()}] RefreshConfigTimer ticked: Checking if user is authenticated...`);
      if (this.$sdkAuth.isUserAuthenticated()) {
        this.$log.debug(`[${moment()}] RefreshConfigTimer ticked: User is authenticated...refreshing configuration.`);
        this.refreshConfiguration(false);
      } else {
        this.$log.error(`[${moment()}] RefreshConfigTimer ticked: User is NOT authenticated...logging out.`);
        this.logout('Auth has expired before config refresh.');
      }
    },

    retrySelectConfiguration() {
      this.isConfigurationErrorDialogVisible = false;
      this.refreshConfiguration(true);
    },

    saveUserPreferences(selectedUnitIDs) {
      this.$store.commit('setUserPreferenceSelectedUnitIDs', selectedUnitIDs);

      bedBoardUtils.raiseBedBoardUserPreferencesUpdated(this.$store.getters.userPreferences);

      this.closeUserPreferencesDialog();
      this.$router.replace({ name: 'home' });
    },

    async selectUnitToView(unit) {
      this.$store.commit('disableTransitionForStayTiles');
      await this.$store.commit('setSelectedUnit', unit);

      if (unit) {
        await this.$router.replace({ name: 'unit' });
      }
    },

    async setConfiguration(showPopupOnError) {
      const userInfo = this.$sdkAuth.getUserInfo('session');
      this.$store.commit('setUserInfo', userInfo);

      const selectedUnitID = this.selectedUnit
        ? this.selectedUnit.bedBoardUnitID.id
        : null;

      await this.$store
        .dispatch('loadConfiguration', {
          providerID: userInfo.providerID,
          scope: this.$sdkAuth.getScope('session'),
          userName: this.$sdkAuth.getUserName('session')
        })
        .then(() => {
          if (selectedUnitID) {
            const units = bedBoardUtils.getUnitsFromHierarchy(
              this.$store.getters.hierarchy,
              [selectedUnitID]
            );
            if (units && units.length > 0) {
              this.$store.commit('setSelectedUnit', units[0]);
            } else {
              this.$store.commit('setSelectedUnit', null);
            }
          } else {
            this.$store.commit('setSelectedUnit', null);
          }
          this.isConfigurationErrorDialogVisible = false;
          this.$log.info(`[${moment().format(appSettings.logDateFormat)}] Successfully retrieved configuration.`);
        })
        .catch((err) => {
          this.isBusyIndicatorVisible = false;
          this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
          if (showPopupOnError) {
            this.isConfigurationErrorDialogVisible = true;
          }
          this.$eventbus.$emit('showToast', { header: 'Error', message: 'Unable to retrieve configuration.', type: 'error' });
        });
    },

    setMyUnits() {
      const myUnits = this.getUnitsFromHierarchy(
        this.$store.getters.hierarchy,
        this.$store.getters.myUnitIDs.map(cf => cf.id)
      );
      this.$store.commit('setMyUnits', myUnits);
    },

    showAbout() {
      this.$store.commit('setSelectedUnit', null);
      this.$router.replace({ name: 'about' });
    },

    showUnitAlerts() {
      this.isUnitAlertsDialogVisible = true;
    },

    showUnitClients() {
      this.isUnitClientsDialogVisible = true;
    },

    showUserPreferences() {
      this.isUserPreferencesDialogVisible = true;
    }
  }
};
</script>

<style lang="scss">
html {
  overflow-y: auto;
}

body {
  color: #666666;
}

a {
  text-decoration: none;
}

.dg-backdrop {
  background-color: rgba(0, 0, 0, 0.4);
}
.dg-btn--cancel {
  border-color: #003a5d !important;
  border-radius: 20px;
  background-color: #003a5d !important;
  font-family: Lato;
  font-size: 12px;
  color: #ffffff !important;
  text-decoration: none solid rgb(255, 255, 255);
  text-align: center;
}
.dg-btn--ok {
  border-color: #003a5d !important;
  border-radius: 20px;
  background-color: #003a5d !important;
  font-family: Lato;
  font-size: 12px;
  color: #ffffff !important;
  text-decoration: none solid rgb(255, 255, 255);
  text-align: center;
}
.dg-content {
  color: #000 !important;
  font-family: Lato;
  font-size: 14px;
}
.dg-content-cont--floating {
  position: relative;
  top: 10%;
  -webkit-transform: none;
  transform: none;
  margin-top: 0;
}
.dg-title {
  color: #000 !important;
  font-family: Lato;
  font-size: 18px;
}
.disable-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
.ntstAppButton {
  border-radius: 20px;
  background-color: #003a5d !important;
  font-family: Lato;
  font-size: 12px;
  color: #ffffff !important;
  text-decoration: none solid rgb(255, 255, 255);
  text-align: center;
}
.ntstAppFooter {
  vertical-align: middle;
}

.ntstAppIcon {
  color: #003b5c !important;
}
.ntstInvertedAppIcon {
  color: #ffffff !important;
  background-color: #003b5c !important;
}
.ntstLoadingLabel {
  color: #333333;
  font-family: 'Lato';
  font-size: 15px;
  font-weight: 700;
}
.ntstSectionTitle {
  color: #333333;
  font-family: 'Lato';
  font-size: 15px;
  font-weight: 700;
}
.ntstValue {
  color: #333333;
  font-family: 'Lato';
  font-size: 13px;
  font-weight: 700;
  margin-right: 5px;
  overflow-wrap: break-word;
}
.ntstValueLabel {
  color: #767676;
  font-family: 'Lato';
  font-size: 15px;
  font-style: italic;
  font-weight: 700;
}

.selectedUnitNavigationTile {
  background-color: #ebebeb;
}

.title {
  margin-left: 0px !important;
}

.titleImage {
  height: 20px;
  margin-bottom: -2px;
}

.titleText {
  color: #003b5c;
  font-size: 20px;
  font-weight: 700;
  padding-left: 5px;
  padding-right: 0px;
  text-decoration: none;
}

.toolbarSelectedUnitTile {
  cursor: default;
  font-size: 20px;
}

.trashbin {
  color: #ff0000 !important;
  margin-left: 15px;
  font-size: 24px;
}
.v-chip .v-chip__content {
  align-items: center;
  height: 17px;
  padding: 0 6px !important;
}
.v-input__append-inner {
  margin-top: 4px !important;
}
.v-label {
  color: #333 !important;
  font-family: Lato;
  font-size: 14px;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0px !important;
}
.v-text-field__details {
  display: none;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  border: 1px solid #ccc !important;
  border-radius: 0px;
  min-height: 0px;
}
.v-text-field--outline input {
  margin-top: 0px !important;
}
.versionLabel {
  color: #767676;
  font-family: 'Lato';
  font-size: 12px;
  font-style: italic;
  margin-right: 10px;
  margin-top: 1px;
}
</style>
